import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { styled } from '@mui/material';
import MuiModal from '@mui/material/Modal';
import MuiBox from '@mui/material/Box';
import { ReactComponent as ForwardRef } from '../../assets/icons/CloseSmall.svg.js';

const Wrapper = styled(MuiBox) `
  border-radius: 12px;
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  align-items: center;
  width: fit-content;
  height: fit-content;
  :focus-visible {
    outline: 0;
  }
  ${({ theme }) => `
    background-color:${theme.palette.N50.main};
  `}
`;
const _CloseSmall = styled(ForwardRef) `
  position: absolute;
  right: 14px;
  top: 14px;
  border-radius: 50%;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.palette.primary.main};
    > path {
      fill: ${({ theme }) => theme.palette.N95.main};
    }
  }
  > path {
    fill: ${({ theme }) => theme.palette.N30.main};
    transform: scale(0.78) translate(2px, 2px);
  }
  transition: all ${({ theme }) => theme.transitions.duration.fast} ease-in-out;
`;
const BasicModal = (_a) => {
    var { className, children, disableBackdropClick, onClose, hasCloseButton, wrapperId } = _a, rest = __rest(_a, ["className", "children", "disableBackdropClick", "onClose", "hasCloseButton", "wrapperId"]);
    const onCloseInternal = useCallback((event, reason) => {
        if (reason === 'backdropClick' && disableBackdropClick) {
            return;
        }
        onClose === null || onClose === void 0 ? void 0 : onClose(event);
    }, [onClose, disableBackdropClick]);
    return (jsx(MuiModal, Object.assign({ "data-testid": "basic-modal", onClose: onCloseInternal }, rest, { children: jsxs(Wrapper, Object.assign({ id: wrapperId, className: className }, { children: [hasCloseButton && jsx(_CloseSmall, { "data-testid": "close-button", onClick: onClose }), children] })) })));
};

export { BasicModal as default };
//# sourceMappingURL=BaseDialog.js.map
